
import React from 'react';
import { Button } from '@/components/ui/button';
import { PlusCircle, X } from 'lucide-react';

interface PromoteTrackButtonProps {
  isCreating: boolean;
  onClick: () => void;
}

const PromoteTrackButton: React.FC<PromoteTrackButtonProps> = ({ isCreating, onClick }) => {
  return (
    <div className="mb-6">
      <Button 
        onClick={onClick}
        className={`w-full py-6 text-lg font-medium ${
          isCreating 
            ? 'bg-gray-400 hover:bg-gray-500' 
            : 'bg-green-500 hover:bg-green-600'
        }`}
      >
        {isCreating ? (
          <>
            <X className="mr-2" />
            Cancel
          </>
        ) : (
          <>
            <PlusCircle className="mr-2" />
            Promote Track
          </>
        )}
      </Button>
    </div>
  );
};

export default PromoteTrackButton;
